import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Cookies from "js-cookie";
import IndexPage from "./pages";
import useAuth from "./hooks/useAuth";
import { lazy, useEffect } from "react";
// DECOMMISSION: registration entry point disabled. Restore with its route.
// import HomePage from "./pages/homepage";
import { SideBarRouteOption } from "./types";
import { ROLE_TO_ROUTES } from "./utils/constants";
import MainLayout from "./components/layouts/MainLayout";
import examinerRoutes from "./utils/routes/examinerRoutes";
import invigilatorRoutes from "./utils/routes/invigilatorRoutes";
import LicencingAdminRoutes from "./utils/routes/licencingAdminRoutes";
import SuspenseWithLoader from "./components/common/SuspenseWithLoader";
import licencingEndUserRoutes from "./utils/routes/licencingEndUserRoutes";
import licencingApprovalOfficesRoutes from "./utils/routes/licencingApprovalOfficesRoutes";

const AcceptInvitation = lazy(
  () => import("@/pages/auth/AcceptInvitation.tsx")
);

const AnalyticsDashboard = lazy(() => import("@/pages/analytics/index"));

const SystemKPIAnalyticsDashboard = lazy(
  () => import("@/pages/system-kpi-analytics/index")
);

const ApprovalOfficerAnalyticsDashboard = lazy(
  () => import("@/pages/approval-officer-analytics/index")
);

const LicencingAdminEducationInstitutions = lazy(
  () => import("@/pages/licencing-admin/education-institutions/index")
);
const LicencingAdminInternshipSites = lazy(
  () => import("@/pages/licencing-admin/internship-sites/index")
);

const LicencingAdminPostSecondaryEducation = lazy(
  () =>
    import(
      "@/pages/licencing-admin/post-secondary-education/professionscategory"
    )
);
const LicencingAdminPostSecondaryEducationExitAward = lazy(
  () => import("@/pages/licencing-admin/post-secondary-education/exitaward")
);
const LicencingAdminSecondaryEducationDocumentTitle = lazy(
  () => import("@/pages/licencing-admin/secondary-education/documenttitle")
);
const LicencingAdminSecondaryEducationProfessionsCredential = lazy(
  () =>
    import(
      "@/pages/licencing-admin/post-secondary-education/professionscredential"
    )
);
const LicencingAdminControlPanelBankConfiguration = lazy(
  () => import("@/pages/licencing-admin/control-panel/bankconfiguration")
);
const LicencingAdminControlPanelIremboConfiguration = lazy(
  () => import("@/pages/licencing-admin/control-panel/irembo-configuration")
);
const LicencingAdminControlPanelLicenceFeeConfiguration = lazy(
  () => import("@/pages/licencing-admin/control-panel/licencefeeconfiguration")
);
const LicencingAdminServicesConfiguration = lazy(
  () => import("@/pages/licencing-admin/control-panel/services-configuration")
);
const LicencingAdminManualApprovals = lazy(
  () => import("@/pages/licencing-admin/control-panel/manual-approvals")
);
const ApprovalStructure = lazy(
  () => import("@/pages/licencing-admin/system-settings/ApprovalStructure")
);
const LicencingAdminRoles = lazy(
  () => import("./pages/licencing-admin/system-settings/LicencingAdminRoles")
);
const AcademicDegreeProgram = lazy(
  () =>
    import(
      "@/pages/licencing-admin/post-secondary-education/academicdegreeprogram"
    )
);
const LicencingAdminSystemUsers = lazy(
  () =>
    import("./pages/licencing-admin/system-settings/LicencingAdminSystemUsers")
);
const LicencingAdminBulkImportUsers = lazy(
  () => import("./pages/licencing-admin/system-settings/bulk-import-users")
);
const LicencingAdminUserMerge = lazy(
  () => import("./pages/licencing-admin/system-settings/user-merge")
);
const LicencingEndUserAnalytics = lazy(
  () => import("./pages/licencing-end-user/statistics")
);
const LicencingEndUserExaminations = lazy(
  () => import("./pages/licencing-end-user/examinations")
);
const LicencingApprovalOfficesAccountStatistics = lazy(
  () => import("./pages/approval-offices-account/statistics")
);

const LicencingApprovalOfficesAccountAllApplications = lazy(
  () =>
    import(
      "./pages/approval-offices-account/application/LicencingApprovalOfficesAccountAllApplications"
    )
);

const LicencingApprovalOfficesAccountApplicationsModifications = lazy(
  () =>
    import(
      "./pages/approval-offices-account/application/LicencingApprovalOfficesAccountApplicationsModifications"
    )
);

const LicencingApprovalOfficesAccountManualAssignRegNo = lazy(
  () =>
    import(
      "./pages/approval-offices-account/modifications/LicencingApprovalOfficesAccountManualAssignRegNo"
    )
);

const LicencingApprovalOfficesAccountAssignRegNo = lazy(
  () =>
    import(
      "./pages/approval-offices-account/modifications/AssignRegNo"
    )
);

const LicencingApprovalOfficesAccountAssignIndex = lazy(
  () =>
    import(
      "./pages/approval-offices-account/modifications/AssignIndex"
    )
);

const LicencingApprovalOfficesAccountManualAssignIndexing = lazy(
  () =>
    import(
      "./pages/approval-offices-account/modifications/LicencingApprovalOfficesAccountManualAssignIndexing"
    )
);
const LicencingApprovalOfficesAccountManualAssignExistingIndex = lazy(
  () =>
    import(
      "./pages/approval-offices-account/modifications/LicencingApprovalOfficesAccountManualAssignExistingIndex"
    )
);

const LicencingApprovalOfficesAccountManualAssignExistingRegistration = lazy(
  () =>
    import(
      "./pages/approval-offices-account/modifications/LicencingApprovalOfficesAccountManualAssignExistingRegistration"
    )
);

const LicencingApprovalOfficesAccountRegistrationTracker = lazy(
  () =>
    import(
      "./pages/approval-offices-account/modifications/RegistrationTracker"
    )
);

const LicencingApprovalOfficesAccountIndexTracker = lazy(
  () =>
    import(
      "./pages/approval-offices-account/modifications/IndexTracker"
    )
);

const LicencingApprovalOfficesAccountOnHoldApplications = lazy(
  () =>
    import(
      "./pages/approval-offices-account/application/LicencingApprovalOfficesAccountOnHoldApplications"
    )
);

const LicencingApprovalOfficesAccountApprovedApplications = lazy(
  () =>
    import(
      "./pages/approval-offices-account/application/LicencingApprovalOfficesAccountApprovedApplications"
    )
);

const LicencingApprovalOfficesAccountExaminationApplications = lazy(
  () =>
    import(
      "./pages/approval-offices-account/application/LicencingApprovalOfficesAccountExaminationApplications"
    )
);


const LicencingApprovalOfficesAccountRejectedApplications = lazy(
  () =>
    import(
      "./pages/approval-offices-account/application/LicencingApprovalOfficesAccountRejectedApplications"
    )
);

const RegistrationFeeApplications = lazy(
  () => import("@/pages/approval-offices-account/ServicesApplications")
);

const CouncilPaymentsAll = lazy(
  () => import("@/pages/approval-offices-account/council-payments")
);
const CouncilPaymentsPending = lazy(
  () => import("@/pages/approval-offices-account/council-payments/pending")
);
const PaymentDetailsPage = lazy(
  () => import("@/pages/approval-offices-account/council-payments/payment-details/[transactionId]")
);

const ApprovalOfficeUserMerge = lazy(
  () => import("@/pages/approval-offices-account/user-merge")
);

// Admin Council Council Payments
const AdminCouncilPaymentsAll = lazy(
  () => import("@/pages/licencing-admin/council-payments")
);
const AdminCouncilPaymentsPending = lazy(
  () => import("@/pages/licencing-admin/council-payments/pending")
);
const AdminPaymentDetailsPage = lazy(
  () => import("@/pages/licencing-admin/council-payments/payment-details/[transactionId]")
);

const ProfileView = lazy(() => import("./pages/profile/Index"));
const UserProfileSettings = lazy(
  () => import("./pages/userprofilesettings/Index")
);

const UserCertificates = lazy(() => import("./pages/usercertificates/Index"));

const UserCertificatesDownload = lazy(
  () => import("./pages/usercertificatesdownload/Index")
);

const UserProfileRecords = lazy(
  () => import("./pages/userprofilerecords/Index")
);

const VerifyEmail = lazy(() => import("@/pages/auth/VerifyEmail.tsx"));
const LoginPage = lazy(() => import("@/pages/auth/login"));
const ResetPassword = lazy(
  () => import("@/pages/auth/reset-password/ResetPassword.tsx")
);

const ResetPasswordByLicense = lazy(
  () =>
    import("@/pages/auth/reset-password-bylicense/ResetPasswordByLicense.tsx")
);
const VerifyResetCode = lazy(
  () => import("@/pages/auth/reset-password/VerifyResetCode.tsx")
);
// DECOMMISSION: registration is deactivated during the HWMS transition.
// RegistrationDisabled is served in place of CreateAccount below; uncomment
// this import and swap the route element back to re-enable registration.
/*
const CreateAccount = lazy(
  () => import("@/pages/create-account/CreateAccount.tsx")
);
*/
const RegistrationDisabled = lazy(
  () => import("@/pages/registration-disabled")
);

const ViewCertificateDetails = lazy(
  () => import("@/pages/certificatedetails/ViewCertificateDetails.tsx")
);
const LicencingAdminCouncilsConfiguration = lazy(
  () => import("@/pages/licencing-admin/control-panel/councils-configuration")
);
const LicencingAdminStudyLevelConfiguration = lazy(
  () =>
    import("@/pages/licencing-admin/control-panel/study-level-configuration")
);
const LicencingAdminFinesConfiguration = lazy(
  () => import("@/pages/licencing-admin/control-panel/fines-configuration")
);
const LicencingAdminExamConfiguration = lazy(
  () => import("@/pages/licencing-admin/control-panel/exam-configuration")
);
const LicencingAdminExamCenterManagement = lazy(
  () => import("@/pages/licencing-admin/control-panel/exam-center-management")
);
const LicencingAdminLanguageManagement = lazy(
  () => import("@/pages/licencing-admin/control-panel/language-management")
);
const LicencingAdminSmtpConfiguration = lazy(
  () => import("@/pages/licencing-admin/control-panel/smtp-configuration")
);
const LicencingAdminInvigilatorShifts = lazy(
  () => import("@/pages/licencing-admin/control-panel/invigilator-shifts")
);
const LicencingAdminAuditLogs = lazy(
  () => import("@/pages/licencing-admin/control-panel/audit-logs")
);

const CertificateVerification = lazy(
  () => import("./pages/verify-certificate")
);

const ExaminerAccountExamSchedules = lazy(
  () => import("./pages/examiner-account/exam-schedules")
);
const ExaminerAccountExamSchedulesCreate = lazy(
  () => import("./pages/examiner-account/exam-schedules/create-exam-schedule")
);
const ExaminerAccountExamSchedulesView = lazy(
  () => import("./pages/examiner-account/exam-schedules/view-exam-schedule")
);
const ExaminerAccountExamSchedulesEdit = lazy(
  () => import("./pages/examiner-account/exam-schedules/edit-exam-schedule")
);
const ExaminerAccountExamSchedulesAnalytics = lazy(
  () => import("./pages/examiner-account/exam-schedules/analytics/[id]")
);

const InvigilatorAccountSessionDetails = lazy(
  () => import("./pages/invigilator-account/exam-schedules/[scheduleId]/sessions/[sessionId]")
);
const InvigilatorAccountUpdateUserDetails = lazy(
  () => import("./pages/invigilator-account/update-user-details")
);
const InvigilatorAccountRoomDetails = lazy(
  () => import("./pages/invigilator-account/rooms/[id]")
);
const InvigilatorAccountShifts = lazy(
  () => import("./pages/invigilator-account/shifts")
);
const ExaminerAccountOverview = lazy(
  () => import("./pages/examiner-account/overview")
);
const InvigilatorAccountOverview = lazy(
  () => import("./pages/invigilator-account/overview")
);
const ExaminerAccountQuestions = lazy(
  () => import("./pages/examiner-account/questions")
);
const ExaminerAccountQuestionsAdd = lazy(
  () => import("./pages/examiner-account/questions/add-questions")
);

const ExaminerEducationPrograms = lazy(
  () => import("./pages/examiner-account/education-programs")
);

const ExaminerEducationProgramsBulkImport = lazy(
  () => import("./pages/examiner-account/education-programs/bulk-import")
);


const ExaminerQuestionCategoriesRedirect = lazy(
  () => import("./pages/examiner-account/question-categories")
);

const NotFound = lazy(() => import("./pages/NotFound"));

// New examination flow components
const VerifyExamSession = lazy(
  () => import("./pages/licencing-end-user/examinations/verify-session")
);
const ExamWaitingRoom = lazy(
  () => import("./pages/licencing-end-user/examinations/waiting-room")
);
const ExaminationInterface = lazy(
  () => import("./pages/licencing-end-user/examinations/exam")
);

const SubmitOnlyPage = lazy(
  () => import("./pages/licencing-end-user/examinations/submit-only")
);
const ExamCompleted = lazy(
  () => import("./pages/licencing-end-user/examinations/completed")
);
const RetakePaymentPage = lazy(
  () => import("./pages/licencing-end-user/examinations/retake-payment")
);
const UserRetakeRequests = lazy(
  () => import("./pages/licencing-end-user/examinations/retake-requests")
);


const ExaminerAppeals = lazy(
  () => import("./pages/examiner-account/appeals")
);
const ExaminerRetakeRequests = lazy(
  () => import("./pages/examiner-account/retake-requests")
);

const ExaminerExamSessionExport = lazy(
  () => import("./pages/examiner-account/exam-session-export")
);

const ExaminerBatchImportExamResults = lazy(
  () => import("./pages/examiner-account/exam-results/batch-import")
);
const ExaminerBatchMonitoring = lazy(
  () => import("./pages/examiner-account/exam-results/batch-monitoring")
);

export const allRoutesWithLayout: {
  path: string;
  routes: SideBarRouteOption[];
  children: { path: string; element: JSX.Element }[];
}[] = [
    {
      path: "/licencing-admin",
      routes: LicencingAdminRoutes,
      children: [
        {
          path: "",
          element: <SystemKPIAnalyticsDashboard />,
        },
        {
          path: "profile",
          element: <ProfileView />,
        },
        {
          path: "control-panel/education-institutions",
          element: <LicencingAdminEducationInstitutions />,
        },
        {
          path: "control-panel/internship-sites",
          element: <LicencingAdminInternshipSites />,
        },
        {
          path: "post-secondary-education/exitaward",
          element: <LicencingAdminPostSecondaryEducationExitAward />,
        },
        {
          path: "post-secondary-education/professions-category",
          element: <LicencingAdminPostSecondaryEducation />,
        },
        {
          path: "post-secondary-education/academic-degree-program",
          element: <AcademicDegreeProgram />,
        },
        {
          path: "control-panel/services-configuration",
          element: <LicencingAdminServicesConfiguration />,
        },
        {
          path: "control-panel/councils-configuration",
          element: <LicencingAdminCouncilsConfiguration />,
        },
        {
          path: "secondary-education/document-title",
          element: <LicencingAdminSecondaryEducationDocumentTitle />,
        },
        {
          path: "post-secondary-education/professions-credential",
          element: <LicencingAdminSecondaryEducationProfessionsCredential />,
        },
        {
          path: "control-panel/bank-configuration",
          element: <LicencingAdminControlPanelBankConfiguration />,
        },
        {
          path: "control-panel/irembo-configuration",
          element: <LicencingAdminControlPanelIremboConfiguration />,
        },
        {
          path: "control-panel/licence-fee-configuration",
          element: <LicencingAdminControlPanelLicenceFeeConfiguration />,
        },
        {
          path: "control-panel/study-level-configuration",
          element: <LicencingAdminStudyLevelConfiguration />,
        },
        {
          path: "control-panel/fines-configuration",
          element: <LicencingAdminFinesConfiguration />,
        },
        {
          path: "control-panel/exam-configuration",
          element: <LicencingAdminExamConfiguration />,
        },
        {
          path: "control-panel/exam-center-management",
          element: <LicencingAdminExamCenterManagement />,
        },
        {
          path: "control-panel/language-management",
          element: <LicencingAdminLanguageManagement />,
        },
        {
          path: "control-panel/smtp-configuration",
          element: <LicencingAdminSmtpConfiguration />,
        },
        {
          path: "control-panel/invigilator-shifts",
          element: <LicencingAdminInvigilatorShifts />,
        },
        {
          path: "control-panel/manual-approvals",
          element: <LicencingAdminManualApprovals />,
        },
        {
          path: "control-panel/audit-logs",
          element: <LicencingAdminAuditLogs />,
        },
        {
          path: "system-settings/users",
          element: <LicencingAdminSystemUsers />,
        },
        {
          path: "system-settings/bulk-import-users",
          element: <LicencingAdminBulkImportUsers />,
        },
        {
          path: "system-settings/user-merge",
          element: <LicencingAdminUserMerge />,
        },
        {
          path: "system-settings/roles",
          element: <LicencingAdminRoles />,
        },
        {
          path: "system-settings/approval-structure",
          element: <ApprovalStructure />,
        },
        {
          path: "council-payments",
          element: <AdminCouncilPaymentsAll />,
        },
        {
          path: "council-payments/pending",
          element: <AdminCouncilPaymentsPending />,
        },
        {
          path: "council-payments/payment-details/:transactionId",
          element: <AdminPaymentDetailsPage />,
        }
      ],
    },
    {
      path: "/end-user-account",
      routes: licencingEndUserRoutes,
      children: [
        {
          path: "",
          element: <LicencingEndUserAnalytics />,
        },
        {
          path: "profile",
          element: <ProfileView />,
        },
        {
          path: "Certificates",
          element: <UserCertificates />,
        },
        {
          path: "examinations",
          element: <LicencingEndUserExaminations />,
        },
        {
          path: "examinations/verify-session",
          element: <VerifyExamSession />,
        },
        {
          path: "examinations/waiting-room/:sessionId",
          element: <ExamWaitingRoom />,
        },
        {
          path: "examinations/completed",
          element: <ExamCompleted />,
        },
        {
          path: "examinations/retake-payment",
          element: <RetakePaymentPage />,
        },
        {
          path: "examinations/retake-requests",
          element: <UserRetakeRequests />,
        },
        {
          path: "licensedownload",
          element: <UserCertificatesDownload />,
        },
        {
          path: "user-profile-settings",
          element: <UserProfileSettings />,
        },
        {
          path: "system-settings/users",
          element: <LicencingAdminSystemUsers />,
        },
        {
          path: "user-profile-record",
          element: <UserProfileRecords />,
        },
      ],
    },
    {
      path: "/approvalofficesaccount",
      routes: licencingApprovalOfficesRoutes,
      children: [
        {
          path: "",
          element: <LicencingApprovalOfficesAccountStatistics />,
        },
        {
          path: "applications/allapplications",
          element: <LicencingApprovalOfficesAccountAllApplications />,
        },
        {
          path: "applications/onholdapplications",
          element: <LicencingApprovalOfficesAccountOnHoldApplications />,
        },
        {
          path: "applications/approved-applications",
          element: <LicencingApprovalOfficesAccountApprovedApplications />,
        },
        {
          path: "applications/examination-applications",
          element: <LicencingApprovalOfficesAccountExaminationApplications />,
        },
        {
          path: "applications/rejected-applications",
          element: <LicencingApprovalOfficesAccountRejectedApplications />,
        },
        {
          path: "registrationfeeapplications/:userApplicationId",
          element: <RegistrationFeeApplications />,
        },
        {
          path: "council-payments",
          element: <CouncilPaymentsAll />,
        },
        {
          path: "council-payments/pending",
          element: <CouncilPaymentsPending />,
        },
        {
          path: "council-payments/payment-details/:transactionId",
          element: <PaymentDetailsPage />,
        },
        {
          path: "analytics",
          element: <ApprovalOfficerAnalyticsDashboard />,
        },
        {
          path: "applications/applications-modification",
          element: <LicencingApprovalOfficesAccountApplicationsModifications />,
        },
        {
          path: "modifications/ManualAssignRegNo",
          element: <LicencingApprovalOfficesAccountManualAssignRegNo />,
        },
        {
          path: "modifications/assign-regno",
          element: <LicencingApprovalOfficesAccountAssignRegNo />,
        },
        {
          path: "modifications/assign-index",
          element: <LicencingApprovalOfficesAccountAssignIndex />,
        },
        {
          path: "modifications/ManualAssignIndexing",
          element: <LicencingApprovalOfficesAccountManualAssignIndexing />,
        },
        {
          path: "modifications/ManualAssignExistingIndex",
          element: <LicencingApprovalOfficesAccountManualAssignExistingIndex />,
        },
        {
          path: "modifications/ManualAssignExistingRegistration",
          element: (
            <LicencingApprovalOfficesAccountManualAssignExistingRegistration />
          ),
        },
        {
          path: "modifications/registration-tracker",
          element: <LicencingApprovalOfficesAccountRegistrationTracker />,
        },
        {
          path: "modifications/index-tracker",
          element: <LicencingApprovalOfficesAccountIndexTracker />,
        },
        {
          path: "system-settings/user-merge",
          element: <ApprovalOfficeUserMerge />,
        },
      ],
    },
    {
      path: "/invigilator-account",
      routes: invigilatorRoutes,
      children: [
        {
          path: "",
          element: <InvigilatorAccountOverview />,
        },
        {
          path: "update-user-details",
          element: <InvigilatorAccountUpdateUserDetails />,
        },
        {
          path: "rooms/:id",
          element: <InvigilatorAccountRoomDetails />,
        },
        {
          path: "rooms/:id/sessions/:sessionId",
          element: <InvigilatorAccountSessionDetails />,
        },
        {
          path: "shifts",
          element: <InvigilatorAccountShifts />,
        }
      ]
    },
    {
      path: "/examiner-account",
      routes: examinerRoutes,
      children: [
        {
          path: "",
          element: <SystemKPIAnalyticsDashboard />,
        },
        {
          path: "exam-schedules",
          element: <ExaminerAccountExamSchedules />,
        },
        {
          path: "exam-schedules/create",
          element: <ExaminerAccountExamSchedulesCreate />,
        },
        {
          path: "exam-schedules/view/:id",
          element: <ExaminerAccountExamSchedulesView />
        },
        {
          path: "exam-schedules/edit/:id",
          element: <ExaminerAccountExamSchedulesEdit />
        },
        {
          path: "exam-schedules/analytics/:id",
          element: <ExaminerAccountExamSchedulesAnalytics />
        },
        {
          path: "questions",
          element: <ExaminerAccountQuestions />,
        },
        {
          path: "questions/add",
          element: <ExaminerAccountQuestionsAdd />,
        },
        {
          path: "education-programs",
          element: <ExaminerEducationPrograms />,
        },
        {
          path: "education-programs/bulk-import",
          element: <ExaminerEducationProgramsBulkImport />,
        },
        {
          path: "question-categories",
          element: <ExaminerQuestionCategoriesRedirect />,
        },
        {
          path: "appeals",
          element: <ExaminerAppeals />,
        },
        {
          path: "retake-requests",
          element: <ExaminerRetakeRequests />,
        },
        {
          path: "exam-session-export",
          element: <ExaminerExamSessionExport />,
        },
        {
          path: "exam-results/batch-import",
          element: <ExaminerBatchImportExamResults />,
        },
        {
          path: "exam-results/batch-monitoring",
          element: <ExaminerBatchMonitoring />,
        }
      ]
    },
  ];

const AuthRoute = () => {
  const token = Cookies.get("token");
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const { user } = useAuth();

  useEffect(() => {
    if (!pathname.includes("/auth/") && token) {

      const allowedRoutes = user?.roles
        ?.map((role) => ROLE_TO_ROUTES[(role as { roleName?: string; name?: string }).roleName ?? (role as { roleName?: string; name?: string }).name ?? ""] ?? [])
        .flat()
        .concat(ROLE_TO_ROUTES.common);
      if (!allowedRoutes?.some((route) => pathname.startsWith(route))) {

        navigate("/");

      }
    }
  }, [navigate, pathname, token, user?.roles]);

  if (token) {
    return <Outlet />;
  }
  return <Navigate to="/auth/login" />;
};

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <SuspenseWithLoader>
            <IndexPage />
          </SuspenseWithLoader>
        }
      />

      {/* DECOMMISSION: the council picker is the registration entry point.
          Restore <HomePage /> here to re-enable it. */}
      <Route
        path="/homepage"
        element={
          <SuspenseWithLoader>
            <RegistrationDisabled />
          </SuspenseWithLoader>
        }
      />
      <Route
        path="/verify-certificate"
        element={
          <SuspenseWithLoader>
            <CertificateVerification />
          </SuspenseWithLoader>
        }
      />

      <Route
        path="/auth/login"
        element={
          <SuspenseWithLoader>
            <LoginPage />
          </SuspenseWithLoader>
        }
      />
      <Route
        path="/auth/forgot-password"
        element={
          <SuspenseWithLoader>
            <ResetPassword />
          </SuspenseWithLoader>
        }
      />
      <Route
        path="/auth/forgot-password-bylicense"
        element={
          <SuspenseWithLoader>
            <ResetPasswordByLicense />
          </SuspenseWithLoader>
        }
      />
      <Route
        path="/auth/reset-password/:code"
        element={
          <SuspenseWithLoader>
            <VerifyResetCode />
          </SuspenseWithLoader>
        }
      />
      <Route
        path="/auth/verify-email"
        element={
          <SuspenseWithLoader>
            <VerifyEmail />
          </SuspenseWithLoader>
        }
      />
      <Route
        path="/auth/accept-invitation"
        element={
          <SuspenseWithLoader>
            <AcceptInvitation />
          </SuspenseWithLoader>
        }
      />

      {/* DECOMMISSION: registration deactivated during the HWMS transition.
          Restore <CreateAccount /> here to re-enable it. */}
      <Route
        path="/create-account/CreateAccount"
        element={
          <SuspenseWithLoader>
            <RegistrationDisabled />
          </SuspenseWithLoader>
        }
      />
      <Route
        path="/certificate-details/ViewCertificateDetails"
        element={
          <SuspenseWithLoader>
            <ViewCertificateDetails />
          </SuspenseWithLoader>
        }
      />

      {/* Standalone Examination Interface - No Layout */}
      <Route
        element={
          <SuspenseWithLoader>
            <AuthRoute />
          </SuspenseWithLoader>
        }
      >
        <Route
          path="/end-user-account/examinations/exam/:sessionId"
          element={
            <SuspenseWithLoader>
              <ExaminationInterface />
            </SuspenseWithLoader>
          }
        />
        <Route
          path="/end-user-account/examinations/submit-only/:sessionId"
          element={
            <SuspenseWithLoader>
              <SubmitOnlyPage />
            </SuspenseWithLoader>
          }
        />
      </Route>

      {/* Protected Auth Routes */}
      <Route
        element={
          <SuspenseWithLoader>
            <AuthRoute />
          </SuspenseWithLoader>
        }
      >
        {allRoutesWithLayout.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <SuspenseWithLoader>
                <MainLayout routes={route.routes} />
              </SuspenseWithLoader>
            }
          >
            {route.children.map((child) => (
              <Route
                key={child.path}
                path={child.path}
                element={
                  <SuspenseWithLoader>{child.element}</SuspenseWithLoader>
                }
              />
            ))}
          </Route>
        ))}
        <Route
          path="/profile"
          element={
            <SuspenseWithLoader>
              <ProfileView />
            </SuspenseWithLoader>
          }
        />
        <Route
          path="/user-profile-settings"
          element={
            <SuspenseWithLoader>
              <UserProfileSettings />
            </SuspenseWithLoader>
          }
        />
        <Route
          path="/user-profile-record"
          element={
            <SuspenseWithLoader>
              <UserProfileRecords />
            </SuspenseWithLoader>
          }
        />
      </Route>
      <Route
        path="*"
        element={
          <SuspenseWithLoader>
            <NotFound />
          </SuspenseWithLoader>
        }
      />
    </Routes>
  );
}
